import { Stack } from '@mui/material';
import { WsTypography } from 'wisestep-base';

const AdminHome = () => (
  <Stack alignItems="center">
    <WsTypography>Admin Layout</WsTypography>
  </Stack>
);
export default AdminHome;
